export default {
    'common.more': 'Expandir',
    'common.collapse': 'collapse',
    'common.noEmpty': 'No puede estar vacío',
    'common.validator.mobile': 'Error de formato de número de teléfono móvil',
    'common.validator.email': 'Error de formato de correo electrónico',
    'common.validator.number': 'Por favor ingrese número correcto',
    'common.validator.password': 'Consta de números, letras y guiones bajos, menos que {length} caracteres',
    'common.validator.maxLength': 'Menos que {length} caracteres',
    'common.btn.search': 'Consulta',
    'common.btn.reset': 'Restablecer',
    'common.btn.refresh': 'Actualizar',
    'common.btn.add': 'Agregar',
    'common.btn.edit': 'Editar',
    'common.btn.delete': 'Eliminar',
    'common.btn.confirm': 'Confirmar',
    'common.btn.cancel': 'Cancelar',
    'common.btn.update': 'Modificar',
    'common.btn.yes': 'Sí',
    'common.btn.no': 'No',
    'common.btn.look': 'Ver',
    'common.btn.operate': 'Operación',
    'common.datePicker.startDate': 'Fecha de inicio',
    'common.datePicker.endDate': 'Fecha de finalización',
    'common.input.placeholder': 'Ingrese',
    'common.default.option': 'Seleccione',
    'common.tip': 'Noticia',
    'common.edit.message': '¿Estás seguro de editar? ',
    'éxito.común': 'éxito',
    'common.total.amount': 'Cantidad total',
    'widget.alert.yes': 'Confirmar',
    'widget.alert.no': 'Cancelar',
    'nav.language': 'Configuración de idioma',
    'nav.language.select': 'Por favor ingrese su idioma',
    'nav.bread.home': 'Inicio',
    'language.zh': 'Chino simplificado',
    'idioma.mx': 'Mexicano',
    'language.en': 'Inglés',
    'language.vi': 'Tiếng việt nam',
    'language.id': 'Indonesio',
    'nav.version': 'información de la versión',
    'version.version': 'número de versión',
    'version.pushUser': 'Productor',
    'version.developer': 'Desarrollador',
    'version.releaseTime': 'Tiempo de lanzamiento',
    'version.content': 'contenido de la versión',
    'nav.login': 'Iniciar sesión',
    'nav.logout': 'Cierre de sesión seguro',
    'nav.logout.tips': 'Se cerrará la sesión del usuario actual y se regresará a la entrada del sistema',
    'nav.logout.confirm': '¿Confirmar para cerrar la sesión del usuario actual? ',
    'nav.password': 'Cambiar contraseña',
    'nav.session.add': 'Agregar cuenta',
    'nav.password.old': 'Contraseña antigua',
    'nav.password.new': 'Nueva contraseña',
    'nav.password.newPasswordConfirm': 'Confirmar nueva contraseña',
    'nav.password.newPasswordConfirm.error': 'Las contraseñas ingresadas dos veces son inconsistentes',
    'nav.historyback': 'Regresar',
    'nav.brand.text': 'Gestión de fondos',
    'nav.account.title': 'Gestión de cuentas',
    'nav.account.item.delete': '¿Confirmar para eliminar esta cuenta? ',
    'nav.account.item.confirm.state': '¿Confirmar para{state}esta cuenta? ',
    'nav.account.company.subTitle': 'lado de la financiación',
    'nav.account.company.searchForm.state': 'Estado de la empresa',
    'nav.account.company.searchForm.stateValue.enable': 'Habilitado',
    'nav.account.company.searchForm.stateValue.disable': 'Deshabilitado',
    'nav.account.company.tableColumn.accountId': 'Id de cuenta',
    'nav.account.company.tableColumn.accountName': 'nombre de la cuenta',
    'nav.account.company.tableColumn.currency': 'moneda',
    'nav.account.company.tableColumn.balance': 'saldo de cuenta',
    'nav.account.company.tableColumn.cardNumber': 'número de tarjeta',
    'nav.account.company.tableColumn.bankName': 'El banco',
    'nav.account.company.tableColumn.phone': 'Número de teléfono reservado',
    'nav.account.company.tableColumn.email': 'Correo electrónico',
    'nav.account.company.tableColumn.createTime': 'Hora de apertura de la cuenta',
    'nav.account.company.tableColumn.updateTime': 'Hora de actualización',
    'nav.account.company.tableColumn.state': 'Estado',
    'nav.account.company.tableColumn.operation': 'Operación',
    'nav.account.company.columnBtn.recharge': 'Recargar',
    'nav.account.company.formData.addTitle': 'Agregar cuenta de empresa',
    'nav.account.company.formData.editTitle': 'Editar cuenta de empresa',
    'nav.account.company.formData.accountName': 'Nombre de la cuenta',
    'nav.account.company.formData.currency': 'moneda',
    'nav.account.company.formData.balance': 'cantidad',
    'nav.account.company.formData.cardNumber': 'número de tarjeta',
    'nav.account.company.formData.bankName': 'Banco',
    'nav.account.company.formData.phone': 'Número de teléfono reservado',
    'nav.account.company.formData.email': 'Correo electrónico',
    'nav.account.company.formData.state': 'Estado',
    'nav.account.company.formData.error.accountName.required': 'El nombre de la cuenta no puede estar vacío',
    'nav.account.company.formData.error.currency.required': 'La moneda no puede estar vacía',
    'nav.account.company.formData.recharge.title': 'Recargar',
    'nav.account.company.formData.recharge.balance': 'saldo de cuenta',
    'nav.account.company.formData.recharge.amount': 'Monto de recarga',
    'nav.account.company.formData.recharge.amount.required': 'El monto de la recarga no puede estar vacío',
    'nav.account.personal.subTitle': 'Lado del activo',
    'nav.account.blacklist.subTitle': 'Gestión de listas negras',
    'nav.account.blacklist.pushItem.title': 'Agregue la siguiente información a la lista negra',
    'nav.account.blacklist.TriggerConditions.title': 'Condición de activación',
    'nav.account.blacklist.TriggerConditions.overdueDays.title': 'Días vencidos >= ',
    'nav.subjectMatter.title': 'Gestión de préstamos',
    'nav.subjectMatter.credit': 'Gestión de Deposito a cliente',
    'nav.subjectMatter.credit.receipt': 'Recibo de pago',
    'nav.subjectMatter.credit.check': 'Revisión de pago',
    'nav.subjectMatter.loan': 'Detalles del Deposito a cliente',
    'nav.subjectMatter.loan.detail': 'Detalles de pago',
    'nav.subjectMatter.repayment': 'Gestión de pagos',
    'nav.subjectMatter.repayment.unpaid': 'Detalles de pago',
    'nav.subjectMatter.repaid.repaid': 'Reembolsado',
    'nav.subjectMatter.repayment.detail': 'Detalles de pago',
    'nav.subjectMatter.repayment.result': 'Resultado del pago',
    'nav.subjectMatter.repayment.penalty': 'Registro de intereses de multas',
    'nav.subjectMatter.cashDetail': 'Detalles del fondo',
    'nav.subjectMatter.cashDetail.table.clumn.customerId': 'ID de cliente',
    'nav.subjectMatter.cashDetail.table.clumn.cameraId': 'ID de caso',
    'nav.subjectMatter.cashDetail.table.clumn.amount': 'Cambiar cantidad',
    'nav.subjectMatter.cashDetail.table.clumn.currency': 'Moneda',
    'nav.subjectMatter.cashDetail.table.clumn.payNo': 'Número de serie del pago',
    'nav.subjectMatter.cashDetail.table.clumn.fundAction': 'Acción de fondo',
    'nav.subjectMatter.cashDetail.table.clumn.fundType': 'Tipo de fondo',
    'nav.subjectMatter.cashDetail.table.clumn.debit': 'Suma-Resta',
    'nav.subjectMatter.cashDetail.table.clumn.remark': 'Información de comentarios',
    'nav.subjectMatter.cashDetail.table.clumn.createTime': 'Hora de creación',
    'nav.subjectMatter.cashDetail.table.clumn.updateTime': 'Hora de actualización',
    'cash.searchForm.cameraId': 'ID de pedido',
    'cash.searchForm.accountId': 'ID de cuenta',
    'cash.searchForm.fundType': 'Tipo de fondo',
    'cash.searchForm.debit': 'Cambiar tipo',
    'cash.tableData.payNo': 'Número de serie',
    'cash.tableData.lid': 'Número de cuenta',
    'cash.tableData.cameraId': 'ID de pedido',
    'cash.tableData.id': 'ID de cuenta',
    'cash.tableData.debit': 'Tipo de cambio',
    'efectivo.tableData.debit.add': 'Suma',
    'cash.tableData.debit.reduce': 'Resta',
    'efectivo.tableData.currency': 'Moneda',
    'cash.tableData.amount': 'Cambiar cantidad',
    'cash.tableData.fundType': 'Tipo de fondo',
    'cash.tableData.fundType.tenant': 'Inquilino',
    'efectivo.tableData.fundType.personal': 'Personal',
    'cash.tableData.fundType.cash': 'Retiro',
    'efectivo.tableData.remark': 'Descripción',
    'efectivo.tableData.observación.ingresos': 'Ingresos:',
    'cash.tableData.remark.expenditure': 'Gasto:',
    'cash.tableData.createTime': 'Hora de creación',
    'repaid.unpaid.searchForm.cameraId': 'ID del pedido',
    'repayment.unpaid.searchForm.shouldTimeDateValue': 'Fecha de reembolso',
    'repayment.unpaid.searchForm.finishTimeDateValue': 'Tiempo de liquidación',
    'repaid.unpaid.searchForm.operateTimeDateValue': 'Tiempo de operación',
    'repago.no pagado.searchForm.payState': 'Estado',
    'repayment.unpaid.searchForm.doubleLoan': 'Si el antiguo cliente',
    'repaid.unpaid.searchForm.personalOperate': 'Operación propia',
    'repago.no pagado.operacion': 'Operacion de prestamo',
    'repayment.unpaid.operation.manual': 'Cancelación manual',
    'repago.no pagado.operación.parcial': 'Reembolso parcial',
    'reembolso.no pagado.operación.sustraer': 'Reducción',
    'reembolso.impago.operación.liquidación': 'Liquidación normal',
    'reembolso.no pagado.operación.extiende': 'Extiende',
    'repayment.unpaid.view': 'Revisa',
    'repayment.unpaid.view.detail': 'Ver detalles de pago',
    'repayment.unpaid.view.result': 'Ver resultado del pago',
    'repayment.unpaid.tableData.cameraId': 'ID de pedido',
    'repayment.unpaid.tableData.productName': 'Nombre del producto',
    'repayment.unpaid.tableData.pauseStatus': 'Suspender cobranza',
    'repayment.unpaid.tableData.noPauseStatus': 'Cobranza no suspendida',
    'repayment.unpaid.tableData.pauseRemark': 'Nota',
    'repayment.unpaid.tableData.dialog.title.pasuse': 'Suspender cobranza de la factura',
    'repayment.unpaid.tableData.dialog.title.resume': 'Reanudar cobranza de la factura',
    'repayment.unpaid.tableData.dialog.hint.pause': 'Ingrese una nota de suspensión',
    'repayment.unpaid.tableData.dialog.hint.resume': 'Ingrese una nota de reanudación',
    'repayment.unpaid.tableData.dialog.btn.cancel': 'Cancelar',
    'repayment.unpaid.tableData.dialog.btn.pause': 'Suspender',
    'repayment.unpaid.tableData.dialog.btn.resume': 'Reanudar',
    'repago.no pagado.tableData.customerName': 'Nombre',
    'repago.no pagado.tableData.indexs': 'Período',
    'repayment.unpaid.tableData.shouldCapital': 'Préstamo original',
    'repayment.unpaid.tableData.factCapital': 'Reembolso del real',
    'repayment.unpaid.tableData.shouldInterest': 'Interés original',
    'repayment.unpaid.tableData.factInterest': 'Interés real pagado',
    'repayment.unpaid.tableData.shouldFine': 'Interés demora original',
    'repayment.unpaid.tableData.factFine': 'Interés demora real pagado',
    'repayment.unpaid.tableData.shouldOtherTotalFee': 'Tarifa de gestión debe pagar',
    'repayment.unpaid.tableData.factOtherTotalFee': 'Tarifa de gestión real pagado',
    'repayment.unpaid.tableData.shouldOverdueFee': 'Multa de incumplimiento debe pagar',
    'repayment.unpaid.tableData.factOverdueFee': 'Multa de incumplimiento real pagado',
    'repayment.unpaid.tableData.subtractAmount': 'Cantidad de la deducción',
    'repayment.unpaid.tableData.shouldTime': 'Tiempo debido',
    'repayment.unpaid.tableData.finishTime': 'Tiempo de liquidación',
    'repayment.unpaid.tableData.isExtends': 'Si extender',
    'repayment.unpaid.tableData.doubleLoan': 'Si el antiguo cliente',
    'repayment.unpaid.tableData.updateTime': 'Tiempo de operación',
    'repago.no pagado.tableData.updateUser': 'Operador',
    'repaid.unpaid.specialviet.form.title': 'Reembolso',
    'repayment.unpaid.specialviet.form.totalAmount': 'Cantidad total adeudada',
    'repayment.unpaid.specialviet.form.paidAmount': 'Esta cantidad de reembolso',
    'repayment.unpaid.specialviet.form.capitalAmount': 'Este principal de reembolso',
    'repayment.unpaid.specialviet.form.interestAmount': 'Este interés de reembolso',
    'repayment.unpaid.specialviet.form.penaltyAmount': 'Este interés de mora de reembolso',
    'repayment.unpaid.specialviet.form.unpaidAmount': 'Cantidad restante sin pagar',
    'repayment.unpaid.specialviet.form.factTime.required': 'El tiempo de pago real no puede estar vacío',
    'repayment.unpaid.specialviet.form.timestatus.label': 'La hora de llegada > la hora real de pago del cliente, menos la penalización adicional',
    'repayment.unpaid.manualDialog.title': 'Operación de cancelación manual',
    'repayment.unpaid.manualDialog.partPaymentData.unpaidAmount': 'Total restante sin pagar',
    'repayment.unpaid.manualDialog.partPaymentData.capitalAmount': 'Principal pendientes de pago',
    'repayment.unpaid.manualDialog.partPaymentData.interestAmount': 'Intereses pendientes de pago',
    'repayment.unpaid.manualDialog.partPaymentData.paidAmount': 'Esta cantidad de reembolso',
    'repayment.unpaid.manualDialog.partPaymentData.writeOffAmount': 'Esta cantidad cancelada',
    'repayment.unpaid.manualDialog.manualRules.paidAmount.required': 'Este monto de reembolso no puede estar vacío',
    'repayment.unpaid.manualDialog.onManualPaidSubmit.success': 'Cancelación exitosa',
    'repayment.unpaid.manualDialog.onPartialPaidSubmit.success': 'Reembolso exitoso',
    'repayment.unpaid.extendsDialog.onExtendsPaidSubmit.success': 'Extensión exitosa',
    'repayment.unpaid.partialDialog.title': 'Operación de reembolso parcial',
    'repayment.unpaid.partialDialog.htitle1': 'Cantidad actual pendiente de pago',
    'repayment.unpaid.partialDialog.htitle2': 'Cálculo de prueba de reembolso',
    'repayment.unpaid.partialDialog.htitle3': 'Tiempo de pago real',
    'repayment.unpaid.partialDialog.remark': 'Observación',
    'repaid.unpaid.partialDialog.unpaidData.paidAmount': 'Total reembolsado',
    'repayment.unpaid.partialDialog.unpaidData.unpaidAmount': 'Total no pagado',
    'repayment.unpaid.partialDialog.unpaidData.capitalAmount': 'Principal no pagado',
    'repayment.unpaid.partialDialog.unpaidData.interestAmount': 'Interés no pagado',
    'repayment.unpaid.partialDialog.unpaidData.penaltyAmount': 'Interés de mora no pagado',
    'repayment.unpaid.partialDialog.unpaidData.feesAmount': 'Tarifa de gestión no pagada',
    'repayment.unpaid.partialDialog.calculateData.inputAmount': 'Esta cantidad de reembolso',
    'repaid.unpaid.partialDialog.calculateData.trialCalculation': 'Cálculo de prueba',
    'repayment.unpaid.partialDialog.calculateData.unpaidAmount': 'Total prueba de reembolso',
    'repayment.unpaid.partialDialog.calculateData.capitalAmount': 'Prueba de reembolso principal',
    'repaid.unpaid.partialDialog.calculateData.interestAmount': 'Prueba de pagar interés',
    'repayment.unpaid.partialDialog.calculateData.penaltyAmount': 'Prueba de pagar interés de mora',
    'repayment.unpaid.partialDialog.calculateData.feesAmount': 'Prueba de pagar tarifa de gestión',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.notNumber': 'Entrada no es un número',
    'repayment.unpaid.partialDialog.calcPartRepaymentHandler.validNumber': 'El monto del reembolso no puede estar vacío o menor/igual a 0',
    'repayment.unpaid.partialDialog.onPartailPaidSubmit.confirm': 'Este monto de reembolso es {inputAmount}, ¿quieres continuar?',
    'repayment.unpaid.substractDialog.title': 'Operación de reducción',
    'repayment.unpaid.substractDialog.htitle2': 'Cálculo de prueba de reducción',
    'repayment.unpaid.substractDialog.htitle3':'Reducción de días atrasados',
    'repayment.unpaid.substractDialog.calculateData.inputAmount': 'Esta cantidad de descuento',
    'repayment.unpaid.substractDialog.calculateData.inputDays':'Días en esta reducción',
    'repayment.unpaidDetail.detailList.shouldOverdueFee':'Gastos de cobranza generados',
    'repayment.unpaid.partialDialog.unpaidData.overdueDyas':'Días de mora generados',
    'repayment.unpaid.substractDialog.calculateData.unpaidAmount': 'Deducción total',
    'repayment.unpaid.substractDialog.calculateData.capitalAmount': 'Reducir principal',
    'repayment.unpaid.substractDialog.calculateData.interestAmount': 'Reducir interés',
    'repayment.unpaid.substractDialog.calculateData.penaltyAmount': 'Reducir interés de mora',
    'repayment.unpaid.substractDialog.calculateData.feesAmount': 'Reducir tarifa de gestión',
    'repayment.unpaid.substractDialog.onPartailPaidSubmit.confirm': 'Este monto de descuento es {inputAmount}, ¿quieres continuar?',
    'repayment.unpaid.settlementDialog.title': 'Operación de liquidación normal',
    'repayment.unpaid.extendsDialog.title': 'Extender',
    'repayment.unpaid.extendsDialog.htitle1': 'Confirmación del monto de la extensión',
    'repayment.unpaid.extendsDialog.unpaidData.extendsAmount': 'Cantidad extendida',
    'repayment.unpaid.extendsDialog.unpaidData.extendsFee': 'Tarifa extensión de administración no pagada',
    'repayment.unpaidDetail.title.repaidDetail': 'Detalles a pagar',
    'repaid.unpaidDetail.title.repaidRecord': 'Registro de reembolso',
    'repayment.unpaidDetail.title.substractRecord': 'Registro de resta',
    'repayment.unpaidDetail.detailList.totalAmount': ' Cantidad del reembolso debo',
    'repayment.unpaidDetail.detailList.couponAmount': 'Cantidad del descuento cupón',
    'repayment.unpaidDetail.detailList.paidAmount': 'Cantidad pagado',
    'repayment.unpaidDetail.detailList.unpaidAmount': 'Reembolso total restante',
    'repayment.unpaidDetail.detailList.capitalAmount': 'Principal restante',
    'repago.unpaidDetail.detailList.interestAmount': 'Interés restante',
    'repayment.unpaidDetail.detailList.penaltyAmount': 'Interés de mora restante',
    'repayment.unpaidDetail.detailList.feesAmount': 'Otras tarifas',
    'repayment.unpaidDetail.recordList.id': 'Número de serie de rembolso',
    'repayment.unpaidDetail.recordList.factTime': 'Hora real de recibo',
    'repayment.unpaidDetail.recordList.factAmount': 'Cantidad real de recibo',
    'repayment.unpaidDetail.recordList.factCapital': 'Principal real de recibo',
    'repayment.unpaidDetail.recordList.factInterest': 'Interés real de recibo',
    'repayment.unpaidDetail.recordList.factFine': 'Interés de mora real de recibo',
    'repayment.unpaidDetail.recordList.factFeeAmount': 'Otras tarifas',
    'repayment.unpaidDetail.recordList.remark': 'Comentario',
    'repayment.unpaidDetail.recordList.updateRemark': 'Modificar comentario de pago',
    'repayment.unpaidDetail.recordList.updateRemark.success': 'Modificado con éxito',
    'repago.unpaidDetail.substractList.operator': 'Operador',
    'repayment.unpaidDetail.substractList.factTime': 'Tiempo de reducción',
    'repayment.unpaidDetail.substractList.factAmount': 'Reducción total',
    'repayment.unpaidDetail.substractList.factCapital': 'Reducir capital',
    'repayment.unpaidDetail.substractList.factInterest': 'Reducir interés',
    'repayment.unpaidDetail.substractList.factFine': 'Reducir interes de mora',
    'repayment.unpaidDetail.substractList.factFeeAmount': 'Reducir otras tarifas',
    'repayment.unpaidDetail.substractList.remark': 'Comentario',
    'repayment.unpaidDetail.lastIndex': 'Pasado periodo',
    'repayment.unpaidDetail.nextIndex': 'Próximo período',
    'repaid.penalty.searchForm.cameraId': 'ID del pedido',
    'repaid.penalty.searchForm.shouldTimeDateValue': 'Fecha de vencimiento',
    'repaid.penalty.tableData.cameraId': 'ID de pedido',
    'repayment.penalty.tableData.productName': 'Nombre del producto',
    'repago.penalty.tableData.customerName': 'Nombre',
    'repago.penalty.tableData.indexs': 'Período',
    'repayment.penalty.tableData.shouldFine': 'Interese de mora acumulado',
    'repayment.penalty.tableData.factFine': 'Pago real de interese de mora',
    'repago.penalty.tableData.state': 'Estado',
    'repayment.penalty.tableData.shouldTime': 'Tiempo de vencimiento de reembolso',
    'repago.penalty.view': 'Revisar',
    'repago.doblePréstamo.primero': 'No',
    'repago.doblePréstamo.doble': 'Sí',
    'repago.personalOperate.self': 'Propio',
    'repago.personalOperate.all': 'Todo',
    'operación.penalización.reembolso': 'Operación',
    'loan.searchForm.cameraId': 'ID de pedido',
    'loan.searchForm.cardNo': 'Número de documento',
    'loan.searchForm.state': 'Estado',
    'loan.searchForm.releaseTime': 'Tiempo de préstamo',
    'prestamo.searchForm.customerName': 'Nombre',
    'loan.searchForm.phone': 'Número de teléfono móvil',
    'loan.tableData.cameraId': 'ID de pedido',
    'loan.tableData.productName': 'Nombre del producto',
    'préstamo.tableData.customerName': 'Nombre',
    'loan.tableData.contractAmount': 'Cantidad del contrato de préstamo',
    'loan.tableData.amount': 'Monto del préstamo',
    'loan.tableData.interest': 'Interés total',
    'loan.tableData.feeAmount': 'Comisión de gestión',
    'loan.tableData.loanCycle': 'Plazo',
    'loan.tableData.rate': 'Tasa de interés',
    'prestamo.tableData.estado': 'Estado',
    'loan.tableData.createTime': 'Tiempo de inspección termina',
    'loan.tableData.loanCreateTime': 'Tiempo de creación',
    'loan.tableData.reviewTime': 'Hora de inspección',
    'loan.tableData.releaseTime': 'Tiempo de préstamo',
    'préstamo.tableData.operación': 'Operación',
    'loan.tableData.cancelLoan': 'Cancelar préstamo',
    'loan.tableData.view': 'Ver plan de pago',
    'loan.tableData.viewRepayment': 'Ver detalles de pago',
    'loan.tableData.loanState.init': 'Inspección pendiente',
    'loan.tableData.loanState.lending': 'Prestado',
    'loan.tableData.loanState.finish': 'Pagado',
    'loan.tableData.loanState.writeoff': 'Cancelación manual',
    'préstamo.tableData.loanState.cancel': 'Cancelar',
    'loan.tableData.loanState.fail': 'Falló el préstamo',
    'loan.tableData.loanState.refuse': 'Rechazo de inspección',
    'loan.tableData.loanState.transaction': 'En proceso de transferencia',
    'loan.tableData.rateType.day': 'Tasa de día{tasa}%',
    'loan.tableData.rateType.month': 'Interés mensual {tasa}%',
    'loan.tableData.rateType.year': 'Interés anual {tasa}%',
    'loan.tableData.loanCycleUnit.day': '{loanCycle}día',
    'loan.tableData.loanCycleUnit.month': '{loanCycle}mes',
    'loan.confirm.cancelLoan': '¿Confirma cancelar la oferta?',
    'loan.cancelLoan.success': '¡Cancelar con éxito!',
    'loadetail.tableData.id': 'ID',
    'loandetail.tableData.productName': 'Nombre del producto',
    'detalledelprestamo.tableData.customerName': 'Nombre',
    'loandetail.tableData.indexs': 'Sesión',
    'loandetail.tableData.shouldCapital': 'El principal adeudados',
    'loandetail.tableData.factCapital': 'Reembolso real del principal',
    'loandetail.tableData.shouldInterest': 'Interés adeudados',
    'loandetail.tableData.factInterest': 'Interés real pagado',
    'loandetail.tableData.shouldFine': 'Interés de mora adeudados',
    'loandetail.tableData.factFine': 'Interés de mora real pagado ',
    'loandetail.tableData.shouldOtherTotalFee': 'Tarifa de administración adeudado',
    'loandetail.tableData.factOtherTotalFee': 'Tarifa de gestión real pafado',
    'loandetail.tableData.shouldOverdueFee': 'Daños liquidados adeudados',
    'loandetail.tableData.factOverdueFee': 'Daños liquidados reales pagado',
    'loandetail.tableData.shouldTime': 'Fecha vencimiento',
    'loandetail.tableData.factTime': 'Hora real de recepción',
    'loandetail.tableData.view': 'Revisar',
    'credit.check.tableData.bankName': 'Nombre del banco',
    'credit.check.tableData.bankCard': 'Número de tarjeta bancaria',
    'credit.check.tableData.phone': 'Número de teléfono móvil',
    'credit.check.tableData.cardNo': 'Número de certificado',
    'credit.check.aciton.view': 'Revisar',
    'credit.check.aciton.check': 'Auditoría',
    'credit.check.button.reject': 'Rechazar',
    'credit.check.button.approve': 'Aceptar',
    'credit.check.button.batchReview': 'Revisión por lotes',
    'credit.check.dialog.remark': 'Observación',
    'credit.check.dialog.rejected': 'Rechazado',
    'credit.check.dialog.approved': 'Aprobado',
    'repago.estado.repagado': 'Reembolsado',
    'repago.estado.no pagado': 'No reembolsado',
    'repago.estado.normal': 'Reembolso normal',
    'reembolso.estado.atrasado': 'Atrasado',
    'repaid.state.afterOverdue': 'Reembolso después de vencido',
    'repaid.state.partial': 'Reembolso parcial',
    'repayment.state.afterPartial': 'Liquidado después pago parcial',
    'repaid.state.manual': 'Anulación manual',
    'repago.estado.cancel': 'Cancelar',
    'repayment.isExtends.notExtends': 'No extendido',
    'repaid.isExtends.extending': 'Extendiendo',
    'repaid.isExtends.extends': 'Extendido',
    // Anulación de cobranza
    'repago.hx.status': 'Estado',
    'repayment.hx.overrideType': 'Tipo de anulación',
    'repago.hx.orderNumber': 'Número de pedido',
    'repayment.hx.repaymentAmount': 'Monto del reembolso',
    'repayment.hx.createTime': 'Hora de creación',
    'repayment.hx.updateTime': 'Hora de actualización',
    'repago.hx.createUserName': 'Creador',
    'repayment.hx.updateUserName': 'Actualizador',
    'repayment.hx.viewCredentials': 'Ver Credenciales',
    'repago.hx.operando': 'Operar',
    'repayment.hx.manualOverride': 'Anulación manual',
    'repaid.hx.partialRepayment': 'Reembolso parcial',
    'repago.hx.normalSettlement': 'Liquidación normal',
    'repago.hx.cancel': 'Cancelar',
    'repaid.tallyBillState.waitApprove': 'Pendiente de inspección',
    'repayment.tallyBillState.finishApprove': 'Anulación termine',
    'repago.tallyBillState.cancelApprove': 'Cancelado',
    'repayment.tallyBillType.inbursaRepay': 'Use INBURSA para pagar',
    'repayment.tallyBillType.overdueRepay': 'Anulación después pago muy vendicido',
    'repayment.hx.noVoucherUpload': 'El documento actual no ha subido el comprobante',
    'repayment.hx.stateNotSupportOperation': 'El estado actual no admite la operación',
    'repayment.hx.cancelSuccess': 'Cancelar con éxito',
    'repayment.hx.sureCancel': '¿Estás seguro de cancelar?',
    'repayment.hx.cancelFailed': 'La cancelación falló, verifíquelo',
    'nav.subjectMatter.repayment.hx': 'Gestión de anulación de cobranza',
    /** Gestión de pagos */
    'common.isDelete': '¿Eliminar?',
    'status.NameNoNull': 'El estado no puede ser vacio',
    'sync.member': 'Información de miembro de sincronización',
    'typeList.filter.time': 'Hora de creación',
    'resultado.cantidad': 'Cantidad',
    'callRecord.filter.serialId': 'Número de serie',
    'serviceFee.userId': 'ID de usuario',
    'merchant.scenario': 'Escenario',
    'icon.copy': 'Copiar',
    'notice.StatusNoNull': 'El estado del aviso no puede estar vacío', // NoticeStatusNoNull
    'payType.name': 'Tipo de pago', // payType
    'payType.NoNull': 'El tipo de pago no puede estar vacío', // payTypeNoNull
    'merchant.StatusNoNull': 'El inquilino no puede estar vacío', // comercianteStatusNoNull
    'pri.NoNull': 'Ordenar no puede estar vacío', // priNoNull
    'batch.add': 'Agregar lote',
    'bank.id': 'ID del banco',
    'bank.name': 'Nombre del banco',
    'banco.icono': 'Icono',
    'bank.tel': 'Número de contacto',
    'bank.website': 'Sitio web oficial',
    'bank.promptMsg': 'Texo de noticia',
    'bank.payType': 'Método de pago',
    'bank.status': 'estado', // status
    'bank.disable': 'Deshabilitar',
    'banco.habilitar': 'Habilitar',
    'bank.addDialogTitle': 'Agregar banco',
    'banco.inválido': 'inválido', // invalid
    'banco.efectivo': 'efectivo', // effective
    'bank.isBatchEnable': '¿Habilitar?',
    'bank.isBatchDisable': '¿Deshabilitar?',
    'bank.title': 'Banco', // bank
    'bank.config': 'Banco configuración de inquilinos', // bankConfig
    'banco.inquilino': 'inquilino', // tenant
    'bank.merchantNoNull': 'El inquilino no puede estar vacío',
    'bank.NoNull': 'El banco no puede estar vacío',
    'bank.thridName': 'Nombre de tres partes',
    'bank.thridBankNameNoNull': 'El nombre de la tercera parte no puede estar vacío', // thridBankNameNoNull
    'bankCardManage.userId': 'ID de usuario',
    'bankCardManage.userName': 'Nombre',
    'bankCardManage.realName': 'Nombre completo',
    'bankCardManage.firstName': 'Nombre',
    'bankCardManage.lastName': 'Apellido',
    'bankCardManage.expirationYear': 'Año de vencimiento',
    'bankCardManage.expirationMonth': 'Mes de vencimiento',
    'bankCardManage.cvv2': 'Código seguridad de tarjeta crédito',
    'bankCardManage.tel': 'Número de teléfono',
    'bankCardManage.IDCard': 'Número de documento',
    'bankCardManage.idType': 'Tipo de documento',
    'bankCardManage.cardNum': 'Número de tarjeta',
    'bankCardManage.oprType': 'Tipo de préstamo',
    'bankCardManage.cardType': 'Tipo de tarjeta',
    'bankCardManage.email': 'Correo electrónico',
    'bankCardManage.bankName': 'Nombre del banco',
    'bankCardManage.bankId': 'BankId',
    'bankCardManage.status': 'Estado',
    'bankCardManage.createTime': 'Hora de creación',
    'bankCardManage.merchantId': 'Id de inquilino',
    'bankCardManage.addDialogTitle': 'Agregar administración de tarjeta bancaria de usuario',
    'bankCardManage.normal': 'Normal',
    'bankCardManage.habilitar': 'Habilitar',
    'bankCardManage.notenable': 'No habilitado',
    'bankCardManage.disable': 'Congelar',
    'bankCardManage.identityType': 'Identificación',
    'bankCardManage.debitCard': 'Tarjeta de Débito',
    'bankCardManage.creditCard': 'tarjeta de crédito',
    'bankCardManage.semiCreditCard': 'Tarjeta de semicrédito',
    'bankCardManage.prepaidCard': 'Tarjeta Prepago',
    'bankCardManage.valid': 'Si verificar',
    'bankCardManage.notCheck': 'No verificado',
    'bankCardManage.passedCheck': 'Verificación aprobada',
    'bankCardManage.failedCheck': 'Verificación fallida',
    'bankCardManage.checking': 'Verificando',
    'bankCardManage.cardNumNoNull': 'El número de tarjeta no puede estar vacío',
    'bankCardManage.identityNoNull': 'El número de documento no puede estar vacío',
    'bankCardManage.merchantIdNoNull': 'Inquilino ID no puede estar vacío',
    'bankCardManage.bankIdNoNull': 'Banco ID no puede estar vacía',
    'bankCardManage.isBatchDisable': '¿Congelarse?',
    'bankCardManage.ifscCode': 'IFSCCode',
    'returnCode.channelNoNull': 'Seleccione canal',
    'returnCode.paymentTypeNoNull': 'Seleccione tipo de pago',
    'returnCode.name': 'Codigo de retorno', // returnCode
    'returnCode.returnMsg': 'Mensaje de retorno',
    'sales.failCount': 'Vezes de préstamos fallidos',
    'sales.note': 'Nota',
    'sales.documentsState': 'Estado de los documentos',
    'sales.updateTime': 'Hora de creación',
    'sales.operation': 'funcionar',
    'sales.generateScreenshot': 'Obtener captura de pantalla',
    'sales.download': 'descargar',
    'sales.toast': 'Error en la generación... Existen valores nulos en los datos.',
    'sales.documentsNo': 'Número de recibo',
    'ventas.realName': 'Nombre real',
    'sales.bankCardNo': 'Número de tarjeta bancaria',
    'repay.add': 'Agregar',
    'repay.reviewed': 'Revisado',
    'repay.doing': 'Procesando',
    'repay.completed': 'Completado',
    'repay.refused': 'Rechazado',
    'repay.paying': 'Pagando',
    'repay.pending': 'Pendiente',
    'repay.paymentSuccess': 'Pago exitoso',
    'repay.paymentFail': 'Pago fallido',
    'repay.abnormal': 'Anormal',
    'statusType.submitted': 'Enviar',
    'statusType.pending': 'Por determinar',
    'statusType.procesamiento': 'Procesando',
    'statusType.completed': 'Completado',
    'statusType.error': 'Error',
    'bank.bankNameNoNull': 'El nombre del banco no puede estar vacío',
    'bank.realNameCannot be empty': 'El nombre completo no puede estar vacío',
    'bank.phoneNoNull': 'El número de teléfono de contacto no puede estar vacío',
    'lending.FinancialCodeExpired': 'Código financiero caducado',
    'lending.HasBeenCancelled': 'Cancelado',
    'chargeback.add': 'Agregar',
    'chargeback.deducting': 'Deduciendo',
    'chargeback.completeOfPart': 'Parcialmente completo',
    'chargeback.closed': 'Cerrado',
    'chargeback.allCpplete': 'Todo completado',
    'chargeback.expireDate': 'Caducado',
    'chargeback.exception': 'Anormal',
    'deduct.DocumentStatus': 'Estado del documento',
    'deduct.RepaidCode': 'Código de Reembolso',
    'deduct.RepaymentPeriodTime': 'Período de reembolso',
    'deduct.ShouldAlsoAmount': 'Cantidad adeudada',
    'deduct.RepayAmount': 'Importe del reembolso',
    'deduct.ActualAmount': 'Importe real del reembolso',
    'deduct.expireDate': 'Tiempo de vencimiento',
    'deduct.createTime': 'Hora de creación',
    'deduct.realAmount': 'Cantidad Real',
    'deduct.purchaseCurrency': 'Moneda de pago del usuario',
    'Generar código de devolución': 'Generar código de pago',
    'Código de devolución': 'Método de código de pago',
    'Prueba de reembolso': 'Prueba de reembolso',
    'Intentar devolver el principal': 'Intentar pagar el principal',
    'Intentar pagar intereses': 'Intentar pagar interese',
    'Intentar pagar una sanción': 'Intentar pagar interes de mora',
    'Trial management fee': 'Intentar pagar tarifa de gescion',
    'Total de prueba': 'Intentar pagar todo',
    'Canal de pago': 'Canal de pago',
    'channel.loanDocuments': 'Recibio de préstamo',
    'channel.orderNo': 'Número de pedido',
    'channel.outcomeId': 'Número de recibio de préstamo',
    'channel.oanApplicationDate': 'Fecha de solicitud de préstamo',
    'channel.loanAmount': 'Cantidad del préstamo',
    'channel.loanTime': 'Tiempo real de recibir préstamo',
    'channel.pleaseEnterTheLoanTime': 'Seleccione el tiempo de préstamo',
    'channel.lendingDate': 'Fecha real de recibir préstamo',
    'channel.lendingApplyDate': 'Fecha de préstamo solicitud',
    'channel.payingDate': 'Tiempo real de reembolso',
    'canal.nombre': 'Nombre',
    'channel.idNo': 'ID No.',
    'canal.bvn': 'BVN',
    'channel.payStatus': 'Estado del pago',
    'channel.confirmTheLoan': 'Confirmar préstamo',
    'channel.lendingAgain': 'Volver a prestar',
    'channel.cancelLending': 'Cancelar préstamo',
    'channel.Invalid': 'Invalido',
    'channel.isConfirmTheLoan': '¿Confirmar préstar?',
    'channel.isConfirmTheLoanFailure': '¿Confirma la falla del préstamo?',
    'channel.isLoanSuccess': '¿Confirma el préstamo éxito',
    'channel.isConfirmLendingAgain': '¿Confirma volver a prestar?',
    'channel.isConfirmCancelLending': '¿Confirma cancelar el préstamo?',
    'channel.loanSuccess': 'Préstamo éxito',
    'channel.loanSuccessBatch': 'Préstamo éxito por lotes',
    'channel.manualLending': 'Préstamo manual',
    'channel.systemLending': 'Préstamo por sistema',
    'channel.loanFailure': 'Préstamo fallido',
    'channel.loanExport': 'Exportar',
    'channel.notPaying': 'No paga',
    'channel.changeOprType': 'Cambiar tipo de préstamo',
    'channel.isConfirmChangeOprType': '¿Confirma cambiar el tipo de préstamo?',
    'channel.businessParam': 'Si es cliente antiguo',
    'channel.firstLoan': 'No',
    'channel.doubleLoan': 'Sí',
    'canal.canal': 'Canal',
    'channel.bankCoding': 'Código bancario',
    'channel.NoNull': 'El canal no puede estar vacío', // channelNoNull
    'channel.threePartiesMerchantNumber': 'Número de comerciante de terceros',
    'channel.merchantNoNull': 'El número de comerciante de terceros no puede estar vacío',
    'channel.channelName': 'Nombre del canal',
    'channel.channelID': 'ID del canal',
    'channel.channelNumber': 'Número de canal',
    'channel.createTime': 'Hora de creación',
    'channel.theTemporaryClosureOfOpenTime': 'Hora de apertura de cierre temporal',
    'channel.theTemporaryClosureOfTheEndOfTime': 'Hora de finalización del cierre temporal',
    'channel.rule.channelID': 'Consta de números, letras y guiones bajos, dentro de 20 caracteres',
    'channel.rule.channelName': 'Nombre de regla dentro de 20 caracteres',
    'channel.rule.channelNumber': 'Dentro de 100 caracteres',
    'routing.sorting': 'clasificando', // sorting
    'routing.weight': 'Peso',
    'routing.weightRequired': 'El peso no puede estar vacío',
    'routing.weightInvalid': 'El peso debe ser un número entero no negativo',
    'routing.singleLimit': 'Transacción límite ',
    'routing.singleMinimumLimit': 'Transacción mínimo límite',
    'routing.dailyLimit': 'Límite diario',
    'routing.monthlyAllowance': 'Límite mensual',
    'routing.theTemporaryClosureOfInformation': 'Cierre información por temporal',
    'routing.basicInformation': 'Información básica',
    'routing.lendingDetail': 'Detalles de trancecion de préstamo', // necesita traducir
    'routing.repaymentDetail': 'Detalles de reembolso', // necesita traducir
    'routing.pauseCollection': 'Suspender cobranza',
    'routing.resumeCollection': 'Reanudar cobranza',
    'payment.sourceMerchantId': 'ID de inquilino de origen',
    'pago.targetMerchantId': 'ID de inquilino de destino',
    'base.three.part.config': 'Configuración de parámetros de tres partes',
    'base.tres.part.config.type': 'Tipo de pago',
    'base.tres.parte.config.canal': 'canal',
    'base.tres.part.config.add': 'Agregar en lotes',
    'base.tres.part.config.delete': 'Eliminar',
    'base.tres.parte.config.modificar': 'modificar',
    'base.tres.part.config.id': 'Clave primaria de parámetro',
    'base.tres.part.config.channel.id': 'ID del canal',
    'base.tres.part.config.channel.name': 'Nombre del canal',
    'base.tres.parte.config.pago.tipo': 'Tipo de pago',
    'base.tres.part.config.pago.desc': 'Descripción del tipo de pago',
    'base.tres.part.config.key': 'clave',
    'base.tres.parte.config.valor': 'valor',
    'base.tres.part.rules.key': 'Ingrese la clave',
    'nav.bank.bankcard.title': 'Tarjeta bancaria del usuario',
    'nav.bank.title': 'Tarjeta bancaria',
    'nav.receipt.title': 'Gestión de recibo',
    'nav.receipt.lending.title': 'Recibo de préstamo',
    'nav.receipt.lending.detail.title': 'Detalles del préstamo',
    'nav.receipt.repayment.title': 'Recibo de reembolso',
    'nav.receipt.repayment.detail.title': 'Detalles de pago',
    'nav.routing.title': 'Configuración de enrutamiento',
    'nav.routing.lending.title': 'Enrutamiento de préstamo',
    'nav.routing.repayment.title': 'Enrutamiento de reembolso',
    'nav.channel.title': 'Configuración de canales',
    'nav.channel.compare.title': 'Canal y banco',
    'nav.channel.threepart.title': 'Parámetros del canal',
    'nav.channel.channel.title': 'Lista de canales',
    'nav.channel.merchant.title': 'Configuración de inquilino',
    'nav.channel.bank.title': 'Inquilinos y Bancos',
    'nav.documents.title': 'Solicitud de documentos',
    'documentos.usuario': 'Pagador',
    'documents.transDate': 'Hora de llegada del reembolso',
    'documents.importDate': 'Hora de importación',
    'documents.bindDate': 'Tiempo de enlace',
    'documentos.prestatario': 'prestatario',
    'documents.phone': 'Número de teléfono móvil',
    'documents.status': 'Estado del documento',
    'documentos.operador': 'Operador',
    'documents.number': 'Numero de documento',
    'documents.amount': 'Importe de reembolso',
    'documents.createDate': 'Hora de creación del reembolso',
    'documents.ShouldAlsoAmount': 'Cantidad adeudada',
    'documents.releaseTime': 'Hora de transferencia de prestamo',
    'documents.shouldTime': 'Debería pago tiempo',
    'documents.download': 'descargar plantilla',
    'documentos.importar': 'importar',
    'documents.import.result': 'Importar resultado',
    'documents.import.drag': 'Arrastra archivos aquí, o',
    'documents.import.click': 'Haga clic para cargarsubir',
    'documents.import.tip.maxsize': 'Solo se pueden subir archivos xlsx y no más de',
    'documents.import.type.excel': 'No es un archivo de Excel',
    'documents.import.size.excel': 'El tamaño del archivo no puede exceder {tamaño}M',
    'documents.import.exceed': 'Excede el número de archivos subidos',
    'documentos.bind': 'ligado',
    'documentos.sin consolidar': 'sin consolidar',
    'documents.amount.all': 'Cantidad total',
    'nav.borrow.title': 'Gestión de préstamos',
    'nav.borrow.personal.title': 'Información de préstamos personales',
    'nav.borrow.company.title': 'Información de préstamo',
    'borrow.digisignRegisterStatus': 'Status pendaftaran DigiSign',
    'borrow.digisignRegisterMsg': 'Informasi pendaftaran DigiSign',
    'borrow.digisignActiveStatus': 'Status aktivasi DigiSign',
    'borrow.rdlStatus': 'Status pembukaan akun RDL',
    'borrow.mobile': 'Número de teléfono móvil',
    'borrow.email': 'Correo de usuario',
    'pedir prestado.userName': 'Nama Lengkap',
    'borrow.noktp': 'Nomor KTP',
    'borrow.permanentAddress': 'Tempat lahir',
    'prestar.cumpleaños': 'Tanggal lahir',
    'prestar.sex': 'Jenis Kelamin',
    'prestar.nacionalidad': 'Kewarganegaraan',
    'prestar.provincia': 'provincia',
    'pedir prestado.ciudad': 'Kota',
    'borrow.street': 'Kecamatan',
    'borrow.community': 'Kelurahan',
    'borrow.postcode': 'Kode Pos',
    'borrow.education': 'Pendidikan Terakhir',
    'prestar.religión': 'Agama',
    'pedir prestado.jobCode': 'Pekerjaan',
    'borrow.address': 'Alamat Lengkap',
    'industria.de.préstamo': 'Bidang Pekerjaan',
    'pedir prestado.rdlAccount': 'CUENTA RDL',
    'borrow.userCode': 'ID de usuario',
    'borrow.legalEntityTypeStr': 'Tipo de entidad',
    'borrow.legalEntityName': 'Nombre de la entidad',
    'borrow.legalEntityId': 'ID de entidad',
    'borrow.workField': 'Campo de trabajo',
    'borrow.npwpNum': 'número fiscal',
    'pedir prestado.statusStr': 'Estado',
    'borrow.audit.title': 'Información inspección',
    'borrow.company.image.title': 'Imagen de la empresa',
    'prestar.otra.información.título': 'otra información',
    'repayment.merge.generate': 'Generar código de pago ({count})',
    'repayment.merge.selectedPlans': 'Planes de pago seleccionados',
    'repayment.merge.shouldTime': 'Fecha de vencimiento',
    'repayment.merge.unpaidAmount': 'Importe pendiente',
    'repayment.merge.overdueFee': 'Cargo por mora calculado',
    'repayment.merge.openLink': 'Abrir enlace de pago',
    'repayment.merge.previewFailed': 'Error al calcular el pago combinado',
    'repayment.merge.invalidState': 'Solo se pueden seleccionar facturas pendientes, vencidas o pagadas parcialmente',
    'repayment.merge.sameMainBillRequired': 'Solo se pueden combinar planes de pago de la misma factura principal'
}

